// Control Channel subscription helper
// Handles survey control events: alerts, question changes, and progression updates
import consumer from "./consumer"

export function createControlChannelSubscription(surveyId, userId, callbacks = {}) {
  if (!surveyId) {
    console.warn('ControlChannel: surveyId required for subscription');
    return null;
  }

  return consumer.subscriptions.create(
    {
      channel: "ControlChannel",
      survey_id: surveyId
    },
    {
      connected() {
        console.log(`ControlChannel connected: survey ${surveyId}`);
      },

      disconnected() {
        console.log(`ControlChannel disconnected: survey ${surveyId}`);
      },

      received(data) {
        if (!data || !data.type) return;

        console.log('ControlChannel received:', data);

        switch (data.type) {
          case 'alert_only':
            callbacks.onAlert && callbacks.onAlert(data.message, 'alert_only');
            break;

          case 'alert_and_go_to_question':
            callbacks.onAlert && callbacks.onAlert(data.message, 'alert_and_go_to_question');
            break;

          case 'alert_and_end_survey':
            callbacks.onAlert && callbacks.onAlert(data.message, 'alert_and_end_survey');
            break;

          case 'set_next_question':
            callbacks.onSetNextQuestion && callbacks.onSetNextQuestion(data.position);
            break;

          case 'progress':
            callbacks.onProgress && callbacks.onProgress(data);
            break;

          case 'moderator_stats':
            callbacks.onModeratorStats && callbacks.onModeratorStats(data);
            break;

          case 'user_creation':
            callbacks.onUserCreation && callbacks.onUserCreation(data);
            break;

          case 'data_export':
            callbacks.onDataExport && callbacks.onDataExport(data);
            break;

          case 'pptx_export':
            callbacks.onPptxExport && callbacks.onPptxExport(data);
            break;

          case 'hold_progress':
            callbacks.onHoldProgress && callbacks.onHoldProgress(data);
            break;

          default:
            console.warn('ControlChannel: Unknown message type:', data.type);
            // Expose unknown message types to consuming code for optional handling
            callbacks.onUnknownType && callbacks.onUnknownType(data);
        }
      }
    }
  );
}
